import React from 'react';
import { Box, Text } from '@common-fe/common-fe';

import { useShowLockBanner } from '@/modules/core/hooks';
import { useAuthStore } from '@/modules/user/stores';

import { ORG_LOCK_BANNER_HEIGHT } from './OrgLockBanner.constants';

const OrgLockBanner: React.FC = () => {
  const { auth } = useAuthStore();
  const isLockBannerShowed = useShowLockBanner();
  if (!isLockBannerShowed || !auth) return null;
  return (
    <Box
      width="100%"
      height={ORG_LOCK_BANNER_HEIGHT}
      background="warningBorder"
      justify="center"
      align="center"
      pad={{ horizontal: 'm' }}
      style={{
        position: 'fixed',
        zIndex: 1003,
        top: 0,
      }}
    >
      <Text size="large">Your organization has a temporary lock on non-HSA payments.</Text>
    </Box>
  );
};

export default OrgLockBanner;
